import { isPlatformBrowser } from '@angular/common';
import {
  Component,
  Inject,
  Input,
  OnChanges,
  OnInit,
  PLATFORM_ID,
} from '@angular/core';
import { Router } from '@angular/router';
import $ from 'jquery';
import { ToastrService } from 'ngx-toastr';
import { MetaService } from 'src/app/core/services/analytics/meta/meta.service';
import { TikTokService } from 'src/app/core/services/analytics/tik-tok.service';
import { LocalstorageService } from 'src/app/core/services/localstorage.service';
import { ProductsService } from 'src/app/core/services/products/products.service';
import { ShoppingCartService } from 'src/app/core/services/shopping-cart/shopping-cart.service';
import { getPricePerPound } from 'src/app/global/utils';
import { Product } from 'src/app/interfaces/products.interface';
import { ShippingMethodType } from 'src/app/interfaces/salePoints.interface';
declare var $: $;
@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.scss'],
})
export class ProductComponent implements OnInit, OnChanges {
  @Input() public product: Product;
  @Input() public spSelected: any;
  @Input() public home: any;
  @Input() public isB2B: boolean;
  costForGram: number;
  images: string[] = [];

  public checkCobertura: boolean;
  public quantityProduct: number;
  public checkProductIcon: boolean = false;

  constructor(
    private router: Router,
    private productService: ProductsService,
    private shoppingCartService: ShoppingCartService,
    private toastr: ToastrService,
    private localStorage: LocalstorageService,
    private tikTokService: TikTokService,
    private metaService: MetaService,
    @Inject(PLATFORM_ID) private platFormId
  ) {
    this.checkCobertura = (this.productService.coverageChecked === 'SI');
  }

  async ngOnInit() {
    if (isPlatformBrowser(this.platFormId)) {
      if (this.productService.coverageChecked === 'SI' || this.productService.coverageChecked === 'SIN-SESION') {
        this.product.cobertura = true;
      } else {
        this.product.cobertura = false;
      }
    }
    // this.product.add = false;
    this.product.quantity = 0;
    this.shoppingCartService.cart.subscribe((productos) => {
      let prodIndex = productos.findIndex((act) => act.id === this.product.id);
      if (prodIndex > -1) {
        this.product.quantity = productos[prodIndex].quantity;
      } else {
        this.product.quantity = 0;
      }
    });
    this.checkCart();
    // Initialize the value of the control with the value of product.quantity if greater than 0
    this.quantityProduct = this.product.quantity > 0 ? this.product.quantity : null;
  }

  /**
   * Returns the url for the product
   */
  public getProductUrl() {
    if (!this.checkCobertura || this.productService.coverageChecked === 'SIN-SESION') {
      this.openAddressModal();
    } else {
      let slugCategoria = this.product.categoria.toLocaleLowerCase();
      slugCategoria = slugCategoria.replace(/ /g, '-');
      this.router.navigate(['/categories', slugCategoria, this.product.slug]);
    }
  }

  private TrackAddToCartEvent(action: string): void {
    this.tikTokService.trackEvent('ClickAgregarProductoAlCarrito', {
      action,
      id: this.product.id,
      nombre: this.product.nombre,
      sku: this.product.sku,
      categoria: this.product.categoria,
      precio: this.product.precio,
      pesoGramos: this.product.pesoGramos,
      isB2B: this.isB2B ?? false,
      isHome: !!this.home
    })
  }

  private TrackMetaAddToCartEvent(action: string): void {
    this.metaService.trackStandard('AddToCart', {
      value: this.product.precio,
      currency: 'COP',
      contents: [
        {
          id: this.product.id,
          quantity: 1,
          item_price: this.product.precio,
        }
      ],
      content_type: 'product'
    });

    // Evento personalizado para Meta
    this.metaService.trackCustom('ClickAgregarProductoAlCarrito', {
      action,
      id: this.product.id,
      nombre: this.product.nombre,
      sku: this.product.sku,
      categoria: this.product.categoria,
      precio: this.product.precio,
      pesoGramos: this.product.pesoGramos,
      isB2B: this.isB2B ?? false,
      isHome: !!this.home
    });

  }

  /**
   * Returns default image for the products without one
   */
  defaultImage(event: Event): void {
    const defaultImgage = '../../../../assets/icons/header/calypso-logo-renew.svg';
    const elementoImg = event.target as HTMLImageElement;
    elementoImg.src = defaultImgage;
  }

  /**
   * Check products of the shooping cart
   * if match update the product in the services for the ref.
   * @memberof ProductComponent
   */
  public checkCart() {
    if (isPlatformBrowser(this.platFormId)) {
      let cartLocalStorage = JSON.parse(this.localStorage.getItem('cart'));
      if (cartLocalStorage && cartLocalStorage.length > 0) {
        for (let i = 0; i < cartLocalStorage.length; i++) {
          const productCart = cartLocalStorage[i];
          if (productCart.id === this.product.id) {
            this.product.add = true;
            this.product.quantity = productCart.quantity;
            // update product in services
            this.shoppingCartService.addCartAgain(this.product);
          }
        }
      }
    }
  }

  ngOnChanges(): void {
    this.getCostForGram(this.product);
  }

  /**
   * Calculated the cost by gram for a product
   * @param product Order product
   */
  getCostForGram(product: Product) {
    this.costForGram = parseFloat(
      (product.precio / product.pesoGramos).toFixed(2)
    );
  }

  /**
   * Function which sends the link that enters by parameters
   * @param option
   */
  public navigate(product: Product) {
    let slugCategoria = product.categoria.toLocaleLowerCase();
    slugCategoria = slugCategoria.replace(/ /g, '-');
    this.productService.onSendSearchParam('');
    this.productService.onSendCategoryParam(product.categoria);
    this.router.navigate(['/categories', slugCategoria, product.slug]);
  }

  /**
   * Add unit product and update product in the services.
   * @memberof ProductComponent
   */
  public addProduct() {
    let shippingMethod = null;
    let cobertura = '';
    shippingMethod = JSON.parse(this.localStorage.getItem('shippingMethod'));
    cobertura = this.localStorage.getItem('cobertura');
    if (cobertura === 'SIN-SESION') {
      this.openAddressModal();
      return;
    }
    if (cobertura === 'SI') {
      let bodega;
      switch (shippingMethod.type) {
        case ShippingMethodType.IN_STORE:
          bodega = shippingMethod.salePoint.bodega;
          break;
        case ShippingMethodType.SHIPPING:
          bodega = shippingMethod.address.inventario;
          break;
        default:
          break;
      }
      if (this.product.inventarioBodega[bodega] >= this.product.quantity + 1) {
        this.product.quantity++;
        this.product.add = true;
        this.shoppingCartService.addProductsCart(this.product);


        this.TrackAddToCartEvent('add_button');
        this.TrackMetaAddToCartEvent('add_button');
      } else {
        this.toastr.error('No tenemos disponible este producto');
      }
    }
  }

  addQuantityProduct() {
    if (this.quantityProduct > 0) {
      this.product.quantity = this.quantityProduct;
      this.product.add = true;
      this.shoppingCartService.addProductsCart(this.product);
      this.checkProductIcon = true;

      this.TrackAddToCartEvent('b2b_quantity_input');
      this.TrackMetaAddToCartEvent('b2b_quantity_input');
    }
  }

  removeQuantityProduct() {
    this.product.quantity = 0;
    this.product.add = false;
    this.shoppingCartService.addProductsCart(this.product);
  }

  /**
   * Add one more of the product
   * @memberof ProductComponent
   */
  public async moreOneProduct() {
    let shippingMethod = null;
    let cobertura = '';
    shippingMethod = JSON.parse(this.localStorage.getItem('shippingMethod'));
    cobertura = this.localStorage.getItem('cobertura');
    //User without sesion
    if (cobertura === 'SIN-SESION') {
      this.openAddressModal();
      return;
    }
    //User without sesion and coverage
    if (cobertura === 'SI') {
      let bodega;
      switch (shippingMethod.type) {
        case ShippingMethodType.IN_STORE:
          bodega = shippingMethod.salePoint.bodega;
          break;
        case ShippingMethodType.SHIPPING:
          bodega = shippingMethod.address.inventario;
          break;
        default:
          break;
      }
      if (this.product.inventarioBodega[bodega] >= this.product.quantity + 1) {
        this.product.quantity++;
        this.shoppingCartService.addProductsCart(this.product);

        this.TrackAddToCartEvent('plus_button');
        this.TrackMetaAddToCartEvent('plus_button');
      } else {
        alert('Inventario no disponible');
      }
    }
  }

  /**
   * Open the address modal
   */
  openAddressModal() {
    // $('#openAddressListModal').click();
    $('#openDeliverySelector')?.click();
  }

  /**
   * Remove one unit the product
   * If quantity is 0 put add false for remove + -
   * @memberof ProductComponent
   */
  public removeProduct(): void {
    this.product.quantity--;
    if (this.product.quantity === 0) {
      this.product.add = false;
    }
    this.shoppingCartService.addProductsCart(this.product);
  }

  pricePerPound(price: number, weightGramsVariable: number, weightGrams: number) {
    return getPricePerPound(price, weightGramsVariable, weightGrams);
  }

  changeQuantityProduct() {
    this.checkProductIcon = false;
  }

  validateInput(event: any) {
    const input = event.target.value;
    if (input.length > 3) {
      event.target.value = input.slice(0, 3);
    }
    this.quantityProduct = Number(event.target.value);
    this.changeQuantityProduct();
  }

  get weightRangeInPounds(): string {
    if (this.product?.pesoGramosVariable) {
      const libras = this.product.pesoGramosVariable / 500;

      const min = libras * 0.98;
      const max = libras * 1.02;

      const minRounded = Math.round(min * 10) / 10;
      const maxRounded = Math.round(max * 10) / 10;

      return `${minRounded}-${maxRounded}Lb aprox.`;
    }
    return '';
  }

  get weightRangeInKg(): string {
    if (this.product?.pesoGramosVariable) {
      const kilos = this.product.pesoGramosVariable / 1000;

      const min = kilos * 0.98;
      const max = kilos * 1.02;

      const minRounded = Math.round(min * 10) / 10;
      const maxRounded = Math.round(max * 10) / 10;

      return `${minRounded}-${maxRounded}Kg`;
    }
    return '';
  }

  get pricePound(): number {
    if (this.product?.pesoGramosVariable && this.product?.precio) {
      const libras = this.product.pesoGramosVariable / 500;
      const precioPorLibra = this.product.precio / libras;
      return precioPorLibra;
    }
    return 0;
  }

  get formattedPesoGramos(): string {
    this.costForGram = parseFloat(
      (this.product.precio / this.product.pesoGramos).toFixed(2)
    );
    return this.costForGram.toString().replace('.', ',') ?? '0';
  }
}
